const state = {
  person: null,
  user: null,
};

export default state;
